import { PageAccess, GlobalAppAccess, AccessResponse } from "@shared/types"

// Must match backend/app/models/page/access.rb
export const REASONS = {
  REQUIRE_PURCHASE: "PURCHASE_REQUIRED",
  REQUIRE_AUTHENTICATION: "AUTHENTICATION_REQUIRED",
  IS_PRIVATE: "IS_PRIVATE",
  IS_SCHEDULED: "IS_SCHEDULED",
  VIEWABLE_CHILDREN: "VIEWABLE_CHILDREN",
  START_REQUIRED: "START_REQUIRED",
  ALLOW_BROWSING: "ALLOW_BROWSING"
}

// Must match backend/app/models/page/access.rb
export const LEGACY_ACCESS = "INHERIT"

export const isPublic = (access: PageAccess) => {
  return (
    access.inherit === false &&
    access.is_private === false &&
    access.require_purchase === false &&
    access.require_authentication === false
  )
}

export const shouldDisableModalClose = (
  appAccess: GlobalAppAccess,
  currentPageAccessResponse: AccessResponse | null
) => {
  const appDisallowsBrowsing =
    !appAccess.allow_anonymous_browsing &&
    (appAccess.require_sign_in || appAccess.is_subscriber_only)

  const currentPageInheritsGlobalAccess =
    currentPageAccessResponse && "granted" in currentPageAccessResponse
      ? !!currentPageAccessResponse?.data?.global_inheritance
      : true

  const currentPageAccessGranted =
    currentPageAccessResponse && "granted" in currentPageAccessResponse
      ? !!currentPageAccessResponse?.granted
      : true

  return (
    appDisallowsBrowsing &&
    (currentPageAccessResponse
      ? currentPageInheritsGlobalAccess && !currentPageAccessGranted
      : true)
  )
}
